(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-checkout-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    if (!document.querySelector('.Cart--expanded')) return;
    function visible(element) {
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }
    function controls(root) {
      const found = [...root.querySelectorAll('button, a, input[type="submit"], [role="button"]')];
      root.querySelectorAll('*').forEach(element => {
        if (element.shadowRoot) found.push(...controls(element.shadowRoot));
      });
      return found;
    }
    function check() {
      const native = document.querySelector('.Cart--expanded .Cart__Checkout[name="checkout"]');
      if (!native) return;
      const replacement = controls(document).some(element => element !== native && !element.disabled && /checkout/i.test(element.textContent || element.getAttribute('aria-label') || element.value || '') && visible(element));
      const recover = !replacement && (native.classList.contains('mr-checkout-recovery') || !visible(native));
      if (native.classList.contains('mr-checkout-recovery') !== recover) native.classList.toggle('mr-checkout-recovery', recover);
    }
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; check(); });
    });
    setTimeout(() => {
      check();
      observer.observe(document.body, {subtree:true,childList:true});
    }, 4000);
    window.addEventListener('pageshow', check);
    window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-instalment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-instalment')) {
  customElements.define('mr-instalment', class extends HTMLElement {
    connectedCallback() {
      this.prices = JSON.parse(this.querySelector('script').textContent);
      this.form = this.closest('form');
      this.variantHandler = event => this.update(event.detail?.variant?.id);
      this.changeHandler = () => requestAnimationFrame(() => this.update(this.form?.querySelector('[name="id"]')?.value));
      document.addEventListener('variant:changed', this.variantHandler);
      this.form?.addEventListener('change', this.changeHandler);
    }
    update(id) {
      if (!(String(id) in this.prices)) return;
      const amount = Math.round(this.prices[id] / 4) / 100;
      this.querySelector('[data-instalment-amount]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency}).format(amount);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.variantHandler);
      this.form?.removeEventListener('change', this.changeHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
